export const weekday = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
export const dayLength = 1000 * 60 * 60 * 24
export const week = dayLength * 7
export const MISSING_PARAMETERS = "You must at least specify an id of an existing plan, or group, startDate and endDate"
